import { createMuiTheme } from '@material-ui/core/styles';

export const eosTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#e60010',
    },
    secondary: {
      main: '#556679',
    },
  },
  overrides: {
    // @ts-ignore
    RaFilterForm: {
      form: {
        marginTop: '0px',
        minHeight: "64px",
        paddingBottom: "8px"
      },
    },
    RaFilterFormInput: {
      body: {
        alignItems: "center"
      }
    },
    RaButton: {
      label: {
        whiteSpace: "nowrap"
      }
    }
  },
});